<template>
  <div class="panel-card card-lg clearfix">
    <div class="card-left">
      <div v-for="(source , index) in sourcesData" :key="index">
        <div class="card-list" :class="active(source.unique_id)" @click="selected=source.unique_id">
        <h5 class="title-with-icon clearfix">
          <i class="icon-source bg-white">
            <svgicon name="icon-source" width="13" height="13" />
          </i>
          <div>
            <span class="text-blue-dark1">{{sourceHasGate(source.gate_id,source.location_id, source)}}</span>
            <small>{{sourceHasGateRefrenceId(source.gate_id,source.location_id, source)}}</small>
          </div>
        </h5>
        </div>
        </div>
    </div>
    <div class="card-right">
      <div class="card-content d-block">
        <Collapse v-model="activeTab" accordion class="collapse-slider mx-15">
           <CollapseItem :name="index" v-for="(destination, index) of selectedDestination" :key="index">
              <template slot="title">
                {{$t('INDENT_DROP_OFF')}}
                <span class="text-normal ml-5" slot="sub-title">
               {{destination.drop_off_details.name}} - {{ destination.drop_off_details.city }}
                </span>
              </template>
              <div class="flex-container panel-head align-top mt-m10">
                <div class="flex-item">
                  <p>
                   {{$t('INDENT_SHIP_TO')}}:
                   <strong>{{destination.drop_off_details.reference_id}} -
                      {{destination.drop_off_details.name}}</strong>
                  </p>
                  <p>
                    {{$t('INDENT_SOLD_TO')}} :
                    <strong>{{destination.drop_off_details.reference_id}} -
                      {{destination.drop_off_details.name}}</strong>
                  </p>
                </div>
              </div>
              <div class="text-right mb-10">
                <Button type="primary" size="small"
                :disabled="isDisabled"
                @click="saveAll(destination)">
                  {{$t('INDENT_SAVE')}}
                </Button>
              </div>
              <Row class="position-relative">
                <Col :span="15">
                <Table highlight-current-row :data="destination.package_details" max-height="244" ref="tableref" stripe header-bg="false"
                  border-right="true" class="table-fixed cell-pad-0">
                  <Table-column fixed prop="unit_type" label="Unit Type" width="145">
                  </Table-column>
                  <Table-column prop="dispatched" label="Dispatched" width="120">
                     <template slot-scope="Dispatched" >
                       <Input
                       @input="isValueChanged=true"
                       :disabled="isSourceUser('dispatched',destination.source_location_id)"
                       v-numericOnly
                      placeholder="Enter Total" size="mini" v-model="Dispatched.row.dispatched" class="input-blank italic-font p-0" >
                      </Input>
                    </template>
                  </Table-column>
                  <Table-column label="Delivered" width="170">
                    <template slot-scope="Delivered" >
                    <Input 
                    @input="isValueChanged=true"
                    :disabled="isSourceUser('delivered', destination.location_id)"
                      v-numericOnly
                      placeholder="Enter Total" size="mini" v-model="Delivered.row.delivered" class="input-blank italic-font p-0" >
                      </Input>
                    </template>
                  </Table-column>
                  <Table-column label="Returned">
                    <template slot-scope="Returned">
                     <Input 
                     @input="isValueChanged=true"
                     :disabled="isSourceUser('returned', destination.source_location_id)" placeholder="Enter Total" size="mini" v-model="Returned.row.returned" class="input-blank italic-font p-0"  v-numericOnly >
                      </Input>
                    </template>
                  </Table-column>
                </Table>
                </Col>
              </Row>
            </CollapseItem>

        </Collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      id: '',
      types: { DEPOT: 1, VENDOR_DEPOT: 3 },
      activeTab: 0,
      selected: '',
      isValueChanged: false,
      packageData: [],
      sourcesData: [],
      sectionType: {
        DISPATCHED: 6,
        DELIVERED: 7,
        ARRIVED: [5, 17, 18],
        DELIVERY_PENDING: 23,
      },
      statusChecking: null,
    };
  },
  computed: {
    ...mapGetters({
      allReconciliation: 'order/reconciliation',
      isLoading: 'order/isReconciliationLoading',
    }),
    active() {
      return source => (source === this.selected ? 'active' : '');
    },
    selectedDestination() {
      const data = this.sourcesData.find((source) => {
        if (source.unique_id === this.selected) {
          return source.destination;
        }
      });
      return data && data.destination;
    },
    isDisabled() {
      return !this.isValueChanged || !this.$hasPermission('update_handling_reconciliation');
    },
  },
  async created() {
    try {
      this.id = this.$route.params.orderId;
      await this.$store.dispatch('order/reconciliation', this.$route.params.orderId);
      this.sourcesData = this.allReconciliation.orderDetails && cloneDeep(this.allReconciliation.orderDetails.sources);
      this.selected = this.sourcesData && this.sourcesData[0].unique_id;
      this.setIntialValues();
    } catch (err) {
      this.$error({ message: this.$getErr('UNABLE_TO_LOAD') });
    }
  },
  methods: {
    setIntialValues() {
      this.statusChecking = {
        returned: [this.sectionType.DELIVERED, this.sectionType.DELIVERY_PENDING],
        dispatched: [...this.sectionType.ARRIVED, this.sectionType.DISPATCHED],
        delivered: [this.sectionType.DISPATCHED, this.sectionType.DELIVERED, this.sectionType.DELIVERY_PENDING],
      };
    },
    isSourceUser(key, locationId) {
      if (!this.$hasPermission('update_handling_reconciliation')) {
        return true;
      }
      const depot = this.$depot.depot(locationId);
      const vendor = this.$depot.vendor(locationId);
      if (this.statusChecking[key].includes(this.allReconciliation.orderDetails.status)) {
        if ((depot && depot.id === locationId) || (vendor && vendor.id === locationId)) {
          return false;
        }
      }
      return true;
    },
    sourceHasGate(gateId, locationId, source) {
      const depots = this.$depot.otherGate(gateId, locationId);
      return gateId && source.type === this.types.DEPOT ? depots.name
        : source.details.name;
    },
    sourceHasGateRefrenceId(gateId, locationId, source) {
      const depots = this.$depot.otherGate(gateId, locationId);
      return gateId && source.type === this.types.DEPOT
        ? depots.reference_id
        : source.details.reference_id;
    },
    constructPayload(props) {
      const payload = {
        packageItemDetails: {
          destination_id: props.destination_id,
          package_details: props.package_details,
        },
      };
      return payload;
    },
    async saveAll(sourceDestination) {
      const payload = this.constructPayload(sourceDestination);
      const result = await this.$store.dispatch('order/updaterReconciliation', { orderId: this.id, payload });
      if (result && result.error) {
        this.$errorMessage({ message: this.$getErr('RECONCILIATION_ERROR') });
      } else {
        this.$successMessage({ message: this.$getSuccess('RECONCILIATION_SUCCESS') });
      }
    },
  },

};
</script>
